











































































































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import { ProjectManagerSettings, ProjectManagementSettings, ActionButtonOptions, TableSortingOptionsV2, MeasurementPointPresetPhase, resolveTableSorting, toLegacyTableSorting } from "@/data/models/Settings";
import { ProjectManagementSettingsModule } from "@/store/modules/ProjectManagementSettingsModule";
import { defineOwnProjectManagementSettingsClientAccess } from "@/permissions/ClientPermissions";
import { createDefaultProjectManagerSettings } from "@/data/models/Client";
import { updateProjectManagementSettings } from "@/data/repository/SettingsRepository";
import PickerDialogComponent from "@/components/common/PickerDialog.vue";
import { loadClient } from "@/data/repository/ClientRepository";
import { iresSettingsAccess } from "@/permissions/UserPermissions";
import { toNumber } from "lodash";
import SettingsPageMixin from "@/components/settings/SettingsPageMixin";
import {
  WALL_THICKNESS_PRESET_MIN,
  WALL_THICKNESS_PRESET_MAX,
  clampWallThicknessPreset,
  isValidWallThicknessPreset,
} from "@/utils/SketchPresets";
import { getEffectiveUser } from "@/utils/ViewAs";

@Component({
  components: {
    "confirmation-dialog": ConfirmationDialogComponent,
    picker: PickerDialogComponent,
  },
})
export default class ProjectManagerSettingsComponent extends SettingsPageMixin {
  isInitializing = true;

  projectCause = ActionButtonOptions.YELLOW;
  projectAttendees = ActionButtonOptions.RED;
  leakDetectionSketchAndMeasurementPoints = ActionButtonOptions.YELLOW;
  apartmentAttendees = ActionButtonOptions.YELLOW;
  tradeRenovation = ActionButtonOptions.RED;
  canAddMeasurementPointsInApartment = false;
  roomClimateMeasuringPoints = ActionButtonOptions.YELLOW;
  measurementPointPresetPhase = MeasurementPointPresetPhase.LEAK_DETECTION;
  enforceFullDamageAssessment = false;
  dryingSetupEnquiry = false;
  sketchInRooms = ActionButtonOptions.YELLOW;
  presetRoomHeight = 240;
  presetInnerWallThickness = 10;
  presetOuterWallThickness = 30;
  presetPartyWallThickness = 30;
  hintPhotoQuality = false;

  tableSortingV2 = TableSortingOptionsV2.PHASE_TRADE;
  tableAutomaticallyInReport = true;
  quantitySurveyInReport = false;

  presetFlexibleServiceList = false;

  minValue = 0;
  maxValue = 500;

  wallThicknessMinValue = WALL_THICKNESS_PRESET_MIN;
  wallThicknessMaxValue = WALL_THICKNESS_PRESET_MAX;

  errorPresetRoomHeight: string[] = [];
  hasErrorPresetInnerWallThickness = false;
  hasErrorPresetOuterWallThickness = false;
  hasErrorPresetPartyWallThickness = false;

  initialProjectManagerSettings: ProjectManagerSettings = createDefaultProjectManagerSettings();

  yesNoValues = [true, false];
  actionButtonOptions = Object.values(ActionButtonOptions);
  actionButtonOptionsWithoutRed = Object.values(ActionButtonOptions).filter(option => option !== ActionButtonOptions.RED);
  mandatoryActionButtonOptions = Object.values(ActionButtonOptions).filter(option => option !== ActionButtonOptions.HIDE);
  tableSortingOptions = Object.values(TableSortingOptionsV2);
  measurementPointPresetPhaseOptions = Object.values(MeasurementPointPresetPhase);

  @Watch("projectManagementSettings")
  onProjectManagementSettingsChanged() {
    const projectManagerSettings = this.projectManagementSettings.projectManagerSettings;

    if (
      projectManagerSettings && 
      !projectManagerSettings.areDefaultProjectManagerSettings
    ) {
      this.initializeParameters(projectManagerSettings);  
    }
  }

  @Watch("presetRoomHeight")
  onPresetRoomHeightChanged(val: number) {
    if (val < this.minValue) {
      this.presetRoomHeight = 0;
    }
    else if (val > this.maxValue) {
      this.presetRoomHeight = 500;
    }

    this.errorPresetRoomHeight = [];
  }

  @Watch("presetInnerWallThickness")
  onPresetInnerWallThicknessChanged(val: number) {
    this.presetInnerWallThickness = clampWallThicknessPreset(val);
    this.hasErrorPresetInnerWallThickness = false;
  }

  @Watch("presetOuterWallThickness")
  onPresetOuterWallThicknessChanged(val: number) {
    this.presetOuterWallThickness = clampWallThicknessPreset(val);
    this.hasErrorPresetOuterWallThickness = false;
  }

  @Watch("presetPartyWallThickness")
  onPresetPartyWallThicknessChanged(val: number) {
    this.presetPartyWallThickness = clampWallThicknessPreset(val);
    this.hasErrorPresetPartyWallThickness = false;
  }

  get hasChanged() {
    return (
      this.projectCause !== this.initialProjectManagerSettings.projectCause ||
      this.projectAttendees !== this.initialProjectManagerSettings.projectAttendees ||
      this.leakDetectionSketchAndMeasurementPoints !== this.initialProjectManagerSettings.leakDetectionSketchAndMeasurementPoints ||
      this.apartmentAttendees !== this.initialProjectManagerSettings.apartmentAttendees ||
      this.tradeRenovation !== this.initialProjectManagerSettings.tradeRenovation ||
      this.canAddMeasurementPointsInApartment !== this.initialProjectManagerSettings.canAddMeasurementPointsInApartment ||
      this.roomClimateMeasuringPoints !== this.initialProjectManagerSettings.roomClimateMeasuringPoints ||
      this.measurementPointPresetPhase !== this.initialProjectManagerSettings.measurementPointPresetPhase ||
      this.enforceFullDamageAssessment !== this.initialProjectManagerSettings.enforceFullDamageAssessment ||
      this.dryingSetupEnquiry !== this.initialProjectManagerSettings.dryingSetupEnquiry ||
      this.sketchInRooms !== this.initialProjectManagerSettings.sketchInRooms ||
      this.presetRoomHeight !== this.initialProjectManagerSettings.presetRoomHeight ||
      // A number input hands back strings, so compare as numbers: retyping the same value is not a change.
      toNumber(this.presetInnerWallThickness) !== toNumber(this.initialProjectManagerSettings.presetInnerWallThickness) ||
      toNumber(this.presetOuterWallThickness) !== toNumber(this.initialProjectManagerSettings.presetOuterWallThickness) ||
      toNumber(this.presetPartyWallThickness) !== toNumber(this.initialProjectManagerSettings.presetPartyWallThickness) ||
      this.hintPhotoQuality !== this.initialProjectManagerSettings.hintPhotoQuality ||
      this.tableSortingV2 !== this.initialProjectManagerSettings.tableSortingV2 ||
      this.tableAutomaticallyInReport !== this.initialProjectManagerSettings.tableAutomaticallyInReport ||
      this.quantitySurveyInReport !== this.initialProjectManagerSettings.quantitySurveyInReport ||
      this.presetFlexibleServiceList !== this.initialProjectManagerSettings.presetFlexibleServiceList
    );
  }

  /**
   * The range message for the wall thickness group. One line under the three fields rather than
   * one per field: the fields are too narrow to hold the sentence, and the rule is the same for all
   * three. The offending field itself turns red.
   */
  get wallThicknessError() {
    const hasError =
      this.hasErrorPresetInnerWallThickness ||
      this.hasErrorPresetOuterWallThickness ||
      this.hasErrorPresetPartyWallThickness;

    return hasError
      ? this.$t("settings.projectManagement.projectManagerSettings.sketch.errorPresetWallThickness").toString()
      : "";
  }

  get projectManagementSettings() {
    return ProjectManagementSettingsModule.projectManagementSettings;
  }

  get projectManagerSettings() {
    return this.projectManagementSettings.projectManagerSettings;
  }

  get canEdit() {
    return defineOwnProjectManagementSettingsClientAccess();
  }

  /**
   * Whether "Aufmass im Bericht" is shown at all.
   *
   * IRES Project does not read `quantitySurveyInReport` yet, so the setting would do nothing for a
   * client who changed it. It stays visible to IRES only until the app that consumes it ships, which
   * still lets IRES support set it per client. Drop this getter and the `v-if` at that point.
   */
  get canSeeQuantitySurveyInReport() {
    return iresSettingsAccess(getEffectiveUser());
  }

  get readonly() {
    return !this.isEditMode || !this.canEdit;
  }

  get formatActionButtonOptions() {
    return (actionButtonOptions: ActionButtonOptions) => {
      return this.getActionButtonOptionsName(actionButtonOptions);
    };
  }

  get formatActionButtonOptionsAlt() {
    return (actionButtonOptions: ActionButtonOptions) => {
      return this.getActionButtonOptionsName(actionButtonOptions, true);
    };
  }

  get formatTableSortingOptions() {
    return (tableSortingOptions: TableSortingOptionsV2) => {
      return this.getTableSortingOptionsName(tableSortingOptions);
    };
  }

  get formatMeasurementPointPresetPhase() {
    return (option: MeasurementPointPresetPhase) => {
      switch (option) {
        case MeasurementPointPresetPhase.LEAK_DETECTION:
          return this.$t('settings.projectManagement.projectManagerSettings.measurementPoints.measurementPointPresetPhaseOptions.leakDetection').toString();
        case MeasurementPointPresetPhase.DRYING:
          return this.$t('settings.projectManagement.projectManagerSettings.measurementPoints.measurementPointPresetPhaseOptions.drying').toString();
      }
    };
  }

  getActionButtonOptionsName(actionButtonOptions: ActionButtonOptions, alt?: boolean) {
    switch (actionButtonOptions) {
      case ActionButtonOptions.HIDE:
        return alt
          ? this.$t(`settings.projectManagement.projectManagerSettings.actionButtons.options.hideAlt`).toString()
          : this.$t(`settings.projectManagement.projectManagerSettings.actionButtons.options.hide`).toString();   
      case ActionButtonOptions.RED:
        return this.$t(`settings.projectManagement.projectManagerSettings.actionButtons.options.red`).toString();
      case ActionButtonOptions.YELLOW:
        return this.$t(`settings.projectManagement.projectManagerSettings.actionButtons.options.yellow`).toString();  
    }
  }

  getTableSortingOptionsName(tableSortingOptions: TableSortingOptionsV2) {
    switch (tableSortingOptions) {
      case TableSortingOptionsV2.TRADE_PHASE:
        return this.$t(`settings.projectManagement.projectManagerSettings.trades.tableSorting.options.tradePhase`).toString();   
      case TableSortingOptionsV2.APARTMENT_PHASE:
        return this.$t(`settings.projectManagement.projectManagerSettings.trades.tableSorting.options.apartmentPhase`).toString();
      case TableSortingOptionsV2.APARTMENT_TRADE:
        return this.$t(`settings.projectManagement.projectManagerSettings.trades.tableSorting.options.apartmentTrade`).toString();  
      case TableSortingOptionsV2.ROOM_PHASE:
        return this.$t(`settings.projectManagement.projectManagerSettings.trades.tableSorting.options.roomPhase`).toString();
      case TableSortingOptionsV2.ROOM_TRADE:
        return this.$t(`settings.projectManagement.projectManagerSettings.trades.tableSorting.options.roomTrade`).toString();

      default:
        return this.$t(`settings.projectManagement.projectManagerSettings.trades.tableSorting.options.phaseTrade`).toString();
    }
  }

  formatYesNo(value: boolean) {
    return this.$t(`common.${value ? "yes" : "no"}`).toString();
  }

  initializeParameters(
    projectManagerSettings: ProjectManagerSettings,
  ) {
    this.projectCause = projectManagerSettings.projectCause;
    this.projectAttendees = projectManagerSettings.projectAttendees;
    this.leakDetectionSketchAndMeasurementPoints = projectManagerSettings.leakDetectionSketchAndMeasurementPoints ?? ActionButtonOptions.YELLOW;
    this.apartmentAttendees = projectManagerSettings.apartmentAttendees ?? ActionButtonOptions.YELLOW;
    this.tradeRenovation = projectManagerSettings.tradeRenovation ?? ActionButtonOptions.RED;
    this.canAddMeasurementPointsInApartment = projectManagerSettings.canAddMeasurementPointsInApartment;
    this.roomClimateMeasuringPoints = projectManagerSettings.roomClimateMeasuringPoints;
    this.measurementPointPresetPhase = projectManagerSettings.measurementPointPresetPhase ?? MeasurementPointPresetPhase.LEAK_DETECTION;
    this.enforceFullDamageAssessment = projectManagerSettings.enforceFullDamageAssessment;
    this.dryingSetupEnquiry = projectManagerSettings.dryingSetupEnquiry ?? false;
    this.sketchInRooms = projectManagerSettings.sketchInRooms;

    this.initialProjectManagerSettings = projectManagerSettings;

    if (projectManagerSettings.presetRoomHeight !== undefined) {
      this.presetRoomHeight = projectManagerSettings.presetRoomHeight;
    }
    else {
      this.initialProjectManagerSettings.presetRoomHeight = this.presetRoomHeight;
    }

    if (projectManagerSettings.presetInnerWallThickness !== undefined) {
      this.presetInnerWallThickness = projectManagerSettings.presetInnerWallThickness;
    }
    else {
      this.initialProjectManagerSettings.presetInnerWallThickness = this.presetInnerWallThickness;
    }

    if (projectManagerSettings.presetOuterWallThickness !== undefined) {
      this.presetOuterWallThickness = projectManagerSettings.presetOuterWallThickness;
    }
    else {
      this.initialProjectManagerSettings.presetOuterWallThickness = this.presetOuterWallThickness;
    }

    if (projectManagerSettings.presetPartyWallThickness !== undefined) {
      this.presetPartyWallThickness = projectManagerSettings.presetPartyWallThickness;
    }
    else {
      this.initialProjectManagerSettings.presetPartyWallThickness = this.presetPartyWallThickness;
    }

    if (projectManagerSettings.hintPhotoQuality !== undefined) {
      this.hintPhotoQuality = projectManagerSettings.hintPhotoQuality;
    }
    else {
      this.initialProjectManagerSettings.hintPhotoQuality = this.hintPhotoQuality;
    }

    // A client that last saved before the versioned field existed has only the deprecated
    // tableSorting, so the stored option has to be resolved and then treated as if it had been
    // stored in tableSortingV2 all along: otherwise the resolved value differs from the snapshot
    // and an untouched page already offers SICHERN.
    this.tableSortingV2 = resolveTableSorting(projectManagerSettings);
    this.initialProjectManagerSettings.tableSortingV2 = this.tableSortingV2;

    if (projectManagerSettings.tableAutomaticallyInReport !== undefined) {
      this.tableAutomaticallyInReport = projectManagerSettings.tableAutomaticallyInReport;
    }
    else {
      this.initialProjectManagerSettings.tableAutomaticallyInReport = this.tableAutomaticallyInReport;
    }

    if (projectManagerSettings.quantitySurveyInReport !== undefined) {
      this.quantitySurveyInReport = projectManagerSettings.quantitySurveyInReport;
    }
    else {
      this.initialProjectManagerSettings.quantitySurveyInReport = this.quantitySurveyInReport;
    }

    if (projectManagerSettings.presetFlexibleServiceList !== undefined) {
      this.presetFlexibleServiceList = projectManagerSettings.presetFlexibleServiceList;
    }
    else {
      this.initialProjectManagerSettings.presetFlexibleServiceList = this.presetFlexibleServiceList;
    }

    this.isEditMode = false;
  }

  async created() {
    this.isInitializing = true;
    const projectManagerSettings = this.projectManagementSettings.projectManagerSettings;

    if (projectManagerSettings && !projectManagerSettings.areDefaultProjectManagerSettings) {
      this.initializeParameters(projectManagerSettings);
    }
    else {
      const client = await loadClient();
      const defaultProjectManagerSettings = createDefaultProjectManagerSettings();

      if (client?.enableMeasurementPlus !== undefined) {
        defaultProjectManagerSettings.canAddMeasurementPointsInApartment = client.enableMeasurementPlus;
      }

      this.initializeParameters(defaultProjectManagerSettings);
    }
    this.isInitializing = false;
  }

  async doSave() {
    const presetRoomHeight = toNumber(this.presetRoomHeight);

    if (presetRoomHeight < 0 || presetRoomHeight > 500) {
      this.errorPresetRoomHeight.push(this.$t("settings.projectManagement.projectManagerSettings.sketch.errorPresetRoomHeight").toString());
      throw new Error("validation");
    }

    const presetInnerWallThickness = toNumber(this.presetInnerWallThickness);
    const presetOuterWallThickness = toNumber(this.presetOuterWallThickness);
    const presetPartyWallThickness = toNumber(this.presetPartyWallThickness);

    this.hasErrorPresetInnerWallThickness = !isValidWallThicknessPreset(presetInnerWallThickness);
    this.hasErrorPresetOuterWallThickness = !isValidWallThicknessPreset(presetOuterWallThickness);
    this.hasErrorPresetPartyWallThickness = !isValidWallThicknessPreset(presetPartyWallThickness);

    if (this.wallThicknessError) {
      throw new Error("validation");
    }

    const projectManagerSettingsUpdate: ProjectManagerSettings = {
      projectCause: this.projectCause,
      projectAttendees: this.projectAttendees,
      pipeSystem: ActionButtonOptions.HIDE,
      leakDetectionSketchAndMeasurementPoints: this.leakDetectionSketchAndMeasurementPoints,
      apartmentAttendees: this.apartmentAttendees,
      tradeRenovation: this.tradeRenovation,
      canAddMeasurementPointsInApartment: this.canAddMeasurementPointsInApartment,
      roomClimateMeasuringPoints: this.roomClimateMeasuringPoints,
      measurementPointPresetPhase: this.measurementPointPresetPhase,
      enforceFullDamageAssessment: this.enforceFullDamageAssessment,
      dryingSetupEnquiry: this.dryingSetupEnquiry,
      sketchInRooms: this.sketchInRooms,
      presetRoomHeight: presetRoomHeight,
      presetInnerWallThickness: presetInnerWallThickness,
      presetOuterWallThickness: presetOuterWallThickness,
      presetPartyWallThickness: presetPartyWallThickness,
      hintPhotoQuality: this.hintPhotoQuality,
      tableSortingV2: this.tableSortingV2,
      // Written for IRES Project builds that only read the legacy field and throw on an unknown value.
      tableSorting: toLegacyTableSorting(this.tableSortingV2),
      tableAutomaticallyInReport: this.tableAutomaticallyInReport,
      quantitySurveyInReport: this.quantitySurveyInReport,
      presetFlexibleServiceList: this.presetFlexibleServiceList,
      
      areDefaultProjectManagerSettings: false,
    }

    const update: ProjectManagementSettings = {
      ...this.projectManagementSettings,
      projectManagerSettings: projectManagerSettingsUpdate,
    }

    await updateProjectManagementSettings(update);

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.initialProjectManagerSettings = update.projectManagerSettings!!;
  }

  mounted() {
    this.setToolbarTitle(this.$t("settings.projectManagement.projectManagerSettings.title").toString());
  }
}
